import { Component } from '@angular/core';

@Component({
  selector: 'app-done',
  imports: [],
  template: `<svg
  width="32"
  height="32"
  viewBox="0 0 31 31"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="0.813965"
    y="0.760742"
    width="30"
    height="30"
    rx="15"
    fill="#183A25"
  />
  <path
    d="M12.814 22.0103C12.7133 22.007 12.6143 21.983 12.5232 21.94C12.4321 21.8971 12.3507 21.8359 12.284 21.7603L7.284 16.7603C7.18867 16.6985 7.10863 16.6159 7.04992 16.5186C6.9912 16.4213 6.95536 16.312 6.94509 16.1988C6.93482 16.0857 6.95039 15.9717 6.99062 15.8654C7.03086 15.7592 7.09471 15.6635 7.17735 15.5855C7.25999 15.5075 7.35927 15.4494 7.46769 15.4154C7.5761 15.3814 7.69082 15.3725 7.80318 15.3893C7.91554 15.4062 8.02261 15.4483 8.1163 15.5126C8.20998 15.5769 8.28785 15.6616 8.344 15.7603L12.814 20.2003L23.284 9.76034C23.425 9.66895 23.5925 9.62753 23.7598 9.64272C23.9271 9.65791 24.0845 9.72882 24.2067 9.8441C24.3289 9.95938 24.4088 10.1123 24.4337 10.2785C24.4586 10.4446 24.427 10.6143 24.344 10.7603L13.344 21.7603C13.2773 21.8359 13.1959 21.8971 13.1048 21.94C13.0137 21.983 12.9147 22.007 12.814 22.0103Z"
    fill="white"
  />
</svg>
`
})
export class DoneComponent {

}
